exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2EwZfWW0AYDyxKf8UYPowx{width:265px}._1VVzka5W40-aG6rSOpgtJk{width:55px}._2Tv8Vm9cvPSpmd2R-AP5Jn{position:fixed;top:48px;width:320px;bottom:0;z-index:1000001}html[dir=ltr] ._2Tv8Vm9cvPSpmd2R-AP5Jn{right:0}html[dir=rtl] ._2Tv8Vm9cvPSpmd2R-AP5Jn{left:0}._2Tv8Vm9cvPSpmd2R-AP5Jn>div{height:100%}", ""]);
// Exports
exports.locals = {
	"contentPane": "_2EwZfWW0AYDyxKf8UYPowx",
	"sideBar": "_1VVzka5W40-aG6rSOpgtJk",
	"swx": "_2Tv8Vm9cvPSpmd2R-AP5Jn"
};